import { useEffect, useState } from 'react';

import { selectDataMatchId, selectDataUser } from 'connect/selectors';
import { useSelector } from 'react-redux';

import { useOfferService } from './OfferService';

class AnalyticsService {
  constructor({ offerService, user, matchId }) {
    this._offerService = offerService;
    this._user = user;
    this._matchId = matchId;
  }

  get analyticsData() {
    return {
      userId: this._user?.id,
      matchId: this._matchId,
      offerName: this._offerService.offerName,
      offerValue: this._offerService.offerValue,
      offerType: this._offerService.offerType,
    };
  }
}

export const useAnalyticsService = () => {
  const offerService = useOfferService();

  const user = useSelector(selectDataUser);
  const matchId = useSelector(selectDataMatchId);

  const createServiceParams = () => ({
    offerService,
    user,
    matchId,
  });
  const createService = () => new AnalyticsService(createServiceParams());

  const [service, setService] = useState(createService());

  // Only update the service when the states change
  // This way we can use the entire service in useEffect watchers
  // To watch for any changes in the offer state
  useEffect(() => {
    setService(createService());
  }, Object.values(createServiceParams()));

  return service;
};
